import { Controller } from "@hotwired/stimulus"

// Personalizado range form: "Alumna asignada" offers the members whose plan matches the chosen format (1 spot = 1:1,
// more = semi), either as a select or as the user search.
export default class extends Controller {
  static targets = ["format", "student", "search", "hint"]
  static values = { students: Object, blanks: Object, placeholders: Object, hints: Object }

  update() {
    const format = Number(this.formatTarget.value) > 1 ? "semi" : "one_on_one"

    if (this.hasStudentTarget) this.replaceStudentOptions(format)
    if (this.hasSearchTarget) this.resetSearch(format)
    this.hintTarget.textContent = this.hintsValue[format]
  }

  replaceStudentOptions(format) {
    const selected = this.studentTarget.value
    const students = this.studentsValue[format] || []

    this.studentTarget.replaceChildren(
      new Option(this.blanksValue[format], ""),
      ...students.map(([name, id]) => new Option(name, id, false, String(id) === selected))
    )
  }

  // The search now looks among the new format's plans, so the member picked for the other format is dropped.
  resetSearch(format) {
    const search = this.searchTarget.querySelector("[data-controller~='user-search']")
    const url = new URL(search.dataset.userSearchUrlValue, window.location.origin)
    url.searchParams.set("personalized_format", format)
    search.dataset.userSearchUrlValue = url.pathname + url.search

    search.querySelector("[data-user-search-target='hiddenInput']").value = ""
    const input = search.querySelector("[data-user-search-target='searchInput']")
    input.value = ""
    input.placeholder = this.placeholdersValue[format]
  }
}
